// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsUserManagementWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AssignApplicationManagerRequestDto,
  GetNamesRequestDto,
  GetNamesResponseDto,
  SetNameRequestDto,
  UserManagementCompanyDetailsResponseDto,
} from '../..';

export const CappsUserManagementWebApiHandler_assignApplicationManager_Path =
  '/api/web/landlord/v1/user/assignApplicationManager';

export const CappsUserManagementWebApiHandler_assignApplicationManager = (
  postData: AssignApplicationManagerRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, AssignApplicationManagerRequestDto, void>(
    {
      endpoint: CappsUserManagementWebApiHandler_assignApplicationManager_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsUserManagementWebApiHandler_createCappsUser_Path = '/api/web/landlord/v1/user/createCappsUser';

export const CappsUserManagementWebApiHandler_createCappsUser = (client = getClient()) => {
  return httpFrontEndRequest<never, never, void>(
    {
      endpoint: CappsUserManagementWebApiHandler_createCappsUser_Path,
      method: 'POST',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsUserManagementWebApiHandler_getNames_Path = '/api/web/landlord/v1/user/getNames';

export const CappsUserManagementWebApiHandler_getNames = (postData: GetNamesRequestDto, client = getClient()) => {
  return httpFrontEndRequest<never, GetNamesRequestDto, GetNamesResponseDto>(
    {
      endpoint: CappsUserManagementWebApiHandler_getNames_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsUserManagementWebApiHandler_requestApplicationManagerIdVerification_Path =
  '/api/web/landlord/v1/user/requestApplicationManagerIdVerification';

export const CappsUserManagementWebApiHandler_requestApplicationManagerIdVerification = (client = getClient()) => {
  return httpFrontEndRequest<never, never, void>(
    {
      endpoint: CappsUserManagementWebApiHandler_requestApplicationManagerIdVerification_Path,
      method: 'POST',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsUserManagementWebApiHandler_requestApplicationPermissions_Path =
  '/api/web/landlord/v1/user/requestApplicationPermissions';

export const CappsUserManagementWebApiHandler_requestApplicationPermissions = (client = getClient()) => {
  return httpFrontEndRequest<never, never, void>(
    {
      endpoint: CappsUserManagementWebApiHandler_requestApplicationPermissions_Path,
      method: 'POST',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsUserManagementWebApiHandler_setName_Path = '/api/web/landlord/v1/user/setName';

export const CappsUserManagementWebApiHandler_setName = (postData: SetNameRequestDto, client = getClient()) => {
  return httpFrontEndRequest<never, SetNameRequestDto, void>(
    {
      endpoint: CappsUserManagementWebApiHandler_setName_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsUserManagementWebApiHandler_userManagementCompanyDetails_Path =
  '/api/web/landlord/v1/user/userManagementCompanyDetails';

export const CappsUserManagementWebApiHandler_userManagementCompanyDetails = (client = getClient()) => {
  return httpFrontEndRequest<never, never, UserManagementCompanyDetailsResponseDto>(
    {
      endpoint: CappsUserManagementWebApiHandler_userManagementCompanyDetails_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};
